import _ from 'lodash';
import { getAxiosClient } from '~src/api';

export const fetchEditorImagesTags = async () => {
  const httpClient = await getAxiosClient();

  const hasCache = _.has(window.editorConfig, 'sidebarTags.items');

  if (hasCache) {
    return {
      tags: {
        allowNew: false,
        items: window.editorConfig.sidebarTags.items,
      },
    };
  }

  const response = await httpClient.get(
    `${process.env.PARSE_API_URL}/editor_images_tags`
  );
  const items = response.data.data;

  return {
    tags: {
      allowNew: false,
      items,
    },
  };
};
